<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <!-- 收入发票 -->
                    <template v-if="kind === 1">
                        <Col span="12">
                            <FormItem label="开票金额" prop="inv_money">
                                <Input v-model="Forms.inv_money" type="number" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="到账金额" prop="get_money">
                                <Input v-model="Forms.get_money" type="number" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票类型" prop="inv_type">
                                <Select v-model="Forms.inv_type" clearable filterable placeholder="收款类型" class="width-100">
                                    <Option v-for="(item,index) in invTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="开票公司" prop="inv_company_id">
                                <Select v-model="Forms.inv_company_id" clearable filterable placeholder="开票公司" class="width-100">
                                    <Option v-for="(item,index) in invCompanyList" :key="index" :value="item.id">{{item.company}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="上传发票" prop="invoice_image">
                                <Input v-model="Forms.invoice_image" disabled>
                                    <template #append>
                                        <div class="f-center">
                                            <Upload
                                                :show-upload-list="false"
                                                :action="upload_url"
                                                :headers = "{'token': $store.state.token}"
                                                :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                                :max-size="50 * 1024"
                                                :on-success="handleSuccess"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize">
                                                <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                            </Upload>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDownload(Forms.invoice_image)" class="text-violet"><Icon type="md-download" />下载</a>
                                        </div>
                                    </template>
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="选择发票抬头">
                                <Select v-model="check_customer_id" clearable filterable placeholder="开票信息" class="width-100" @on-change="checkCustomer">
                                    <Option v-for="(item,index) in customerList" :key="index" :value="item.id">{{item.company}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票抬头" prop="inv_head">
                                <Input v-model="Forms.inv_head" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票电话" prop="inv_tel">
                                <Input v-model="Forms.inv_tel" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票税号" prop="inv_num">
                                <Input v-model="Forms.inv_num" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票地址" prop="inv_address">
                                <Input v-model="Forms.inv_address" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="开户银行" prop="inv_bank">
                                <Input v-model="Forms.inv_bank" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="银行卡号" prop="inv_bank_card">
                                <Input v-model="Forms.inv_bank_card" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                    </template>

                    <!-- 支出发票 -->
                    <template v-else>
                        <Col span="12">
                            <FormItem label="发票名称" prop="title">
                                <Input v-model="Forms.title" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="开票金额" prop="inv_money">
                                <Input v-model="Forms.inv_money" type="number" clearable placeholder=""/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="发票类型" prop="inv_type">
                                <Select v-model="Forms.inv_type" clearable filterable placeholder="收款类型" class="width-100">
                                    <Option v-for="(item,index) in invTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="开票公司" prop="inv_company_id">
                                <Select v-model="Forms.inv_company_id" clearable filterable placeholder="开票公司" class="width-100">
                                    <Option v-for="(item,index) in companyList" :key="index" :value="item.company_id">{{item.company}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="上传发票" prop="invoice_image">
                                <Input v-model="Forms.invoice_image" disabled>
                                    <template #append>
                                        <div class="f-center">
                                            <Upload
                                                :show-upload-list="false"
                                                :action="upload_url"
                                                :headers = "{'token': $store.state.token}"
                                                :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                                :max-size="50 * 1024"
                                                :on-success="handleSuccess"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize">
                                                <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                            </Upload>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDownload(Forms.invoice_image)" class="text-violet"><Icon type="md-download" />下载</a>
                                        </div>
                                    </template>
                                </Input>
                            </FormItem>
                        </Col>
                    </template>

                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">{{kind === 1 ? '确认开发票' : '确认添加'}}</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedInvoiceConfig, getDispersedInvoiceDetail, saveDispersedInvoice} from "@/apis/dispersed";
import {getCustomerInvoice} from "@/apis/customer";

export default {
    name: 'DispersedInvoiceCreate',
    components: {
    },
    props: {
        kind: {
            type: [Number, String],
            default: 1
        }
    },
    emits: ['trueHandler'],
    data () {
        //通用校验
        const commonRules = {
            inv_money: [
                { required: true, type: 'number', min:0.1,  message: '请输入开票金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
            ],
            inv_type: [
                { required: true, type: 'number',  message: '请选择发票类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
            ],
            inv_company_id: [
                { required: true, type: 'number',  message: '请选择开票公司', trigger: 'change',  transform(value) { return parseInt(value)} }
            ],
            invoice_image: [
                { required: true, message: '请上传发票', trigger: 'blur'}
            ]
        };
        //收入发票额外校验
        const incomeRules = {
            get_money: [
                { required: true, type: 'number', min:0.1,  message: '请输入到账金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
            ],
            inv_head: [
                { required: true, message: '请输入发票抬头', trigger: 'blur'}
            ],
            inv_tel: [
                { required: true, message: '请输入发票电话', trigger: 'blur'}
            ],
            inv_num: [
                { required: true, message: '请输入发票税号', trigger: 'blur'}
            ]
        };
        //支出发票额外校验
        const expendRules = {
            title: [
                { required: true, message: '请输入发票名称', trigger: 'blur'}
            ]
        };
        return {
            isBox : false,
            invTypeList: [],
            invCompanyList: [],
            companyList: [],
            customerList: [],
            check_customer_id: '',

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : this.initForms(),
            Rules : parseInt(this.kind) === 1 ? Object.assign(commonRules, incomeRules) : Object.assign(commonRules, expendRules)
        }
    },
    methods: {
        /**
         * 功能：初始化表单
         * time: 2026/09/13
         **/
        initForms(){
            return {
                invoice_id: '',
                title: '',
                inv_money: '',
                get_money: '',
                inv_type: '',
                inv_company_id: '',
                invoice_image: '',
                inv_head: '',
                inv_tel: '',
                inv_num: '',
                inv_address: '',
                inv_bank: '',
                inv_bank_card: '',
                remark: ''
            };
        },
        /**
         * 功能：选择系统客户后拉取开票信息并自动填充
         * time: 2026/09/13
         **/
        checkCustomer(e){
            let that = this;
            if(!e){
                that.Forms.inv_head = '';
                that.Forms.inv_tel = '';
                that.Forms.inv_num = '';
                that.Forms.inv_address = '';
                that.Forms.inv_bank = '';
                that.Forms.inv_bank_card = '';
                return;
            }
            getCustomerInvoice(e).then(res => {
                let data = res.data ?? {};
                that.Forms.inv_head = data.inv_head ?? '';
                that.Forms.inv_tel = data.inv_phone ?? '';
                that.Forms.inv_num = data.inv_num ?? '';
                that.Forms.inv_address = data.inv_address ?? '';
                that.Forms.inv_bank = data.inv_bank ?? '';
                that.Forms.inv_bank_card = data.inv_bank_card ?? '';
            })
        },
        /**
         * 功能：附件删除
         * time: 2026/09/13
         **/
        FileDelete(){
            this.Forms.invoice_image = "";
        },
        /**
         * 功能：附件下载
         * time: 2026/09/13
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         * 功能：上传成功
         * time: 2026/09/13
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.invoice_image = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         * 功能：配置
         * time: 2026/09/13
         **/
        GetConfig(){
            let that = this;
            getDispersedInvoiceConfig().then(e=>{
                that.invTypeList = e.data.invTypeList ?? [];
                that.invCompanyList = e.data.invCompanyList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.customerList = e.data.customerList ?? [];
            })
        },
        /**
         * 功能：详情
         * time: 2026/09/13
         **/
        GetDetail(invoice_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedInvoiceDetail(invoice_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'invoice_id' || v === 'inv_type' || v === 'inv_company_id') {
                        that.Forms[v] = data[v] !== '' && data[v] !== null && data[v] !== 0 ? parseInt(data[v]) : '';
                    }else{
                        that.Forms[v] = data[v] ?? '';
                    }
                }
            })
        },
        /**
         * 功能：添加
         * time: 2026/09/13
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         * 功能：编辑
         * time: 2026/09/13
         **/
        edit(invoice_id){
            this.isBox = true;
            this.GetConfig();
            if(invoice_id) this.GetDetail(invoice_id);
        },
        /**
         * 功能：提交
         * time: 2026/09/13
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    param.kind = parseInt(that.kind);
                    that.$store.commit('SET_LOADING' , true);
                    saveDispersedInvoice(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         * 功能：重置
         * time: 2026/09/13
         **/
        FormReset(){
            this.isBox = false;
            this.$refs['Forms'] && this.$refs['Forms'].resetFields();
            this.Forms = this.initForms();
            this.check_customer_id = '';
        }
    },
    computed: {
        title(){
            return parseInt(this.kind) === 1 ? '开发票' : '添加发票';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
